import { gql } from 'graphql-request'
import { Sdk } from './__generated__/sdk.generated'

export async function fetchDeveloperApp(sdk: Sdk, id: string) {
  const { app } = await sdk.GetDeveloperApp({ id })
  return app
}

export async function fetchListingByUrl(sdk: Sdk, appId: string, url: string) {
  const { app } = await sdk.GetListingByUrl({ appId, url })
  return app?.listing
}

gql`
  query GetDeveloperApp($id: ID!) {
    app: developerApp(id: $id) {
      id
      automount
    }
  }

  query GetListingByUrl($appId: ID!, $url: String!) {
    app: developerApp(id: $appId) {
      listing(url: $url) {
        ...Script_Listing
      }
    }
  }

  query DeveloperAppListingQuery($developerAppId: ID!, $foreignId: ID!) {
    developerApp(id: $developerAppId) {
      listing(foreignId: $foreignId) {
        ...Script_Listing
      }
    }
  }

  query ListingQuery($listingId: ID!) {
    listing(id: $listingId) {
      ...Script_Listing
    }
  }

  fragment Script_Listing on Listing {
    id
    offerButtonLabel
    published
    shouldShowButtonOnWebsite
    source {
      appId
      foreignId
    }
  }
`
